<template>
    <div class="base-panel">
        <div class="section clbrtn-detail-manage-height">
            <div class="section-body full-height">
                <div class="form-grid">
                    <div class="form-item" v-if="isNewMode">
                        <label>{{ $t("계측기 선택") }}</label>
                        <select class="form-control" v-model="localValue.facilityIdx">
                            <option :value="null">{{ $t("선택") }}</option>
                            <option v-for="(f, idx) in facilityList || []" :key="idx" :value="f.facilityIdx">
                                {{ f.facilityName }}
                            </option>
                        </select>
                    </div>
                    <div class="form-item">
                        <label>{{ $t("처리일자") }}</label>
                        <DatePicker
                            v-model="localValue.processDate"
                            :disabled="!isEditMode"
                            value-type="format"
                            format="YYYY-MM-DD"
                            :editable="false"
                            :clearable="true"
                            input-class="form-control clbrtn-date-picker"
                            placeholder="YYYY-MM-DD"
                        />
                    </div>
                    <div class="form-item">
                        <label>{{ $t("유형") }}</label>
                        <select class="form-control" :disabled="!isEditMode" v-model="localValue.clbrnTypeCode">
                            <option :value="null">{{ $t("선택") }}</option>
                            <option v-for="(code, idx) in clbrnTypeCodeList" :key="idx" :value="code.value">
                                {{ code.text }}
                            </option>
                        </select>
                    </div>
                    <div class="form-item">
                        <label>{{ $t("담당자") }}</label>
                        <input
                            class="form-control"
                            type="text"
                            :disabled="!isEditMode"
                            v-model="localValue.clbrnWorker"
                        />
                    </div>
                    <div class="form-item">
                        <label>{{ $t("업체") }}</label>
                        <input class="form-control" type="text" :disabled="!isEditMode" v-model="localValue.clbrnOrg" />
                    </div>
                    <div class="form-item" style="grid-column: 1 / -1">
                        <label>{{ $t("상세 내역") }}</label>
                        <textarea
                            class="form-control"
                            :disabled="!isEditMode"
                            v-model="localValue.clbrnDescrb"
                            rows="3"
                            placeholder="상세 내역"
                            style="max-height: 200px"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import * as rules from "@src/consts/ruleConsts.js";
import * as validMessage from "@src/consts/validMessageConsts.js";
import * as popupMessages from "@src/consts/popupMessageConsts";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
    props: ["mode", "clbrnTypeCodeList", "selectedRow", "model", "facilityList"],
    components: { DatePicker },
    data() {
        return {
            rules,
            validMessage,
            popupMessages,
            localValue: this.model ? { ...this.model } : this.createEmptyModel(),
            updatingFromParent: false,
        };
    },
    computed: {
        isEditMode() {
            return this.mode === "edit" || this.mode === "new";
        },
        isNewMode() {
            return this.mode === "new";
        },
        isViewMode() {
            return this.mode === "view";
        },
    },
    watch: {
        mode(newVal) {
            if (newVal === "new") {
                const base = this.createEmptyModel();
                base.facilityIdx = base.facilityIdx ?? this.selectedRow?.facilityIdx ?? null;
                this.updatingFromParent = true;
                this.localValue = base;
            }
        },
        model: {
            handler(val) {
                this.updatingFromParent = true;
                const base = val ? { ...val } : this.createEmptyModel();
                if (this.mode === "new" && (base.facilityIdx === null || base.facilityIdx === undefined)) {
                    base.facilityIdx = this.selectedRow?.facilityIdx ?? null;
                }
                this.localValue = base;
            },
            immediate: true,
            deep: true,
        },
        localValue: {
            handler(val) {
                if (this.updatingFromParent) {
                    this.updatingFromParent = false;
                    return;
                }
                this.$emit("update:model", { ...val });
            },
            deep: true,
        },
    },
    methods: {
        createEmptyModel() {
            return {
                clbrtnIdx: null,
                clbrnDescrb: null,
                clbrnTypeCode: null,
                clbrnWorker: null,
                clbrnOrg: null,
                processDate: null,
                facilityIdx: null,
            };
        },
        getSavePayload() {
            if (!this.localValue) return null;
            const facilityIdx = this.localValue?.facilityIdx ?? this.selectedRow?.facilityIdx;
            if (!facilityIdx) return null;
            return { ...this.localValue, facilityIdx };
        },
    },
};
</script>

<style scoped>
.base-panel {
    width: 100%;
    height: 100%;
    /* padding: 20px; */
}

.section {
    margin-bottom: 15px;
}

label {
    font-weight: 600;
    margin-bottom: 5px;
    display: block;
}

.form-control {
    width: 100%;
    padding: 8px 12px;
    border: 1px solid #ced4da;
    border-radius: 4px;
    font-size: 14px;
}

select.form-control {
    height: 38px;
}

textarea.form-control {
    resize: vertical;
    min-height: 80px;
}

.material-icons {
    color: #dc3545;
    vertical-align: middle;
}

.clbrtn-detail-list-height {
    height: 0%;
}

.clbrtn-detail-manage-height {
    height: 100%;
}

.section-body {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: stretch;
}

.full-height {
    height: 100%;
}

.form-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px 12px;
}

.form-item label {
    font-weight: 600;
    margin-bottom: 4px;
    display: block;
}
</style>
